/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Error_Base_Url_Not_HttpsInputs */

const vi_smartlab_irrigation_error_base_url_not_https = /** @type {(inputs: Smartlab_Irrigation_Error_Base_Url_Not_HttpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ máy chủ API tưới phải dùng HTTPS`)
};

/**

* @param {Smartlab_Irrigation_Error_Base_Url_Not_HttpsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_error_base_url_not_https = /** @type {((inputs?: Smartlab_Irrigation_Error_Base_Url_Not_HttpsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Error_Base_Url_Not_HttpsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_error_base_url_not_https(inputs)
});